import React, {useEffect, useState} from 'react';
import * as Actions from '../../Actions';
import { connect, useDispatch, useSelector } from 'react-redux';
// import SchHeadNav from './SchHeadNav';
import SchTableHead from './SchTableHead';
// import SchTableBody from './SchTableBody';
import SchTableBody2 from './SchTableBody2';
import * as comMod from '../../commonModule';
import { 
  SnapberAlert, /*FabAddEdit,*/ /* RadioScheduleEdit */
} from '../common/materialUi';
import * as mui from '../common/materialUi';
import {LoadingSpinner, LoadErr, StdErrorDisplay} from '../common/commonParts';
import SimpleModal from '../common/modal.sample';
import SchDailyDialog from './SchDailyDialog';
import SimpleDialogDemo from '../../DrowerMenu'
import SchSaveLater from './SchSaveLater';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Link, useLocation } from 'react-router-dom';
import {LinksTab} from '../common/commonParts';
import { TrendingUp } from '@material-ui/icons';
import SchUserDispatcher from './SchUsersDispatcher';
import { blue } from '@material-ui/core/colors';
const useStyles = makeStyles({
  linktabRoot: {
    marginTop: 47,
    '& > .MuiButton-text': {
      // margin: theme.spacing(1),
      padding: 0,
    },
  },
  initializing: {
    position: 'fixed', bottom: '10vh', 
    width: '80vw', left: '10vw', background: blue[900],
    color: '#fff', textAlign: 'center', padding: 16,
  },
});
export const menu = [
  // { link: "/schedule", label: "月間" },
  { link: "/schedule/", label: "月間" },
  { link: "/schedule/dsetting/", label: "利用者別日別設定" },
  { link: "/schedule/weekly/", label: "週間" },
  { link: "/schedule/weekly/transfer/", label: "送迎" },
  { link: "/schedule/users/", label: "利用者別" },
  // { link: "/schedule/users2/", label: "利用者別B" },
  { link: "/schedule/calender/", label: "休校・休日設定" },
]
// スケジュールの初期化を行う。
// スケジュール情報がまったくないときは加算情報の初期化を行う
// floatingActionButtonsがあるときは何も出力しないが
// ないときは擬似的に処理中の表示を行う
export const SchInitilizer = () => {
  const getSchCnt = (schedule) =>{
    let schCnt = 0;
    Object.keys(schedule).filter(e=>e.match(/^UID/)).map(e=>{
      if (!schedule[e]){
        console.log('schedule object', e);
        return false;
      }
      schCnt += Object.keys(schedule[e]).filter(f=>f.match(/^D2/)).length
    });
    return schCnt;
  }
  const allstate = useSelector(state=>state);
  const dispatch = useDispatch();
  const classes = useStyles();
  const {
    schedule, controleMode, service, stdDate, dateList, hid, bid,
    users, 
  } = allstate;
  const initDone = controleMode.scheduleInitDone;
  const sendFlug = controleMode.scheduleInitSendFlug;

  const cnt = getSchCnt(schedule);
  const [confirmDisp, setConfirmDisp] = useState(cnt? false: true);
  useEffect(()=>{
    // controlemodeが更新される前に何度もコールされているようなので遅延を入れる
    let schCnt = getSchCnt(schedule);
    console.log(schCnt, 'schCnt');
    // スケジュールのデータの中身がからの場合は再度初期化を行うようにする
    // 上手く動いていないので元に戻す
    // 初期化再び。この条件だとどう？
    if (initDone !== stdDate && !schCnt){
      dispatch(Actions.setStore({controleMode: {
        ...controleMode,
        scheduleInitDone: stdDate, scheduleInitSendFlug: true,
      }}));
      console.log('initdone')
    }
  }, [initDone]);
  useEffect(()=>{
    let isMounted = true;
    if (service && isMounted && sendFlug){
      const p = {
        dateList, stdDate, schedule, hid, bid, users, dispatch, 
        forthUpdate: true,
      }
      dispatch(Actions.setStore({controleMode: {
        ...controleMode,
        scheduleInitSendFlug: false
      }}));
      comMod.addUsersAddictionToSch(p);
      console.log('schedule init.');
    }
    return (()=>{isMounted = false});
  }, [sendFlug]);
  useEffect(()=>{
    let isMounted = true;
    const fabExist = document.querySelector('#floatingActionButtonsExist');
    if (confirmDisp && !fabExist){
      setTimeout(()=>{
        setConfirmDisp(false);
      }, 2000)
    }
    else setConfirmDisp(false);
    return (()=>{isMounted = false});
  }, [])
  if (confirmDisp){
    return (<mui.AddictionConfirming/>)
  }
  return null;
}

const ScheduleMain = (props) => {
  const dispatch = useDispatch();
  const [localFabSch, setLocalFabSch] = useState(0);
  const favSchProps = {localFabSch, setLocalFabSch};
  const users = useSelector(state=>state.users);
  const dateList = useSelector(state=>state.dateList);

  // 日付別利用者数を出すためのstateを定義
  const tmpCountsOfUSe = {};
  const a = Array(dateList.length).fill(0);
  users.map(e=>{tmpCountsOfUSe['UID' + e.uid] = [...a];});
  const [countsOfUse, setCountsOfUse] = useState(tmpCountsOfUSe);
  // 日付別の操作を行う前にストアにdispatchする必要がある。そのためのフラグ
  // const [schStoreDispatch, setSchStoreDispatch] = useState(false);
  const tb2Props = {
    localFabSch, setLocalFabSch, countsOfUse, setCountsOfUse, 
  }
  const service = useSelector(state=>state.service);
  

  return (<>
    <LinksTab menu={menu} />
    <div className='AppPage schedule fixed'>
      <SchTableHead {...tb2Props}/>
    </div>
    <div className='AppPage schedule scroll'>
      <SchTableBody2 {...tb2Props} />
      <SnapberAlert />
      <mui.FabSchedule {...favSchProps}/>
    </div>
    <SchUserDispatcher/>  
    <SchInitilizer/>
  </>)

}

const Sch2 = () => {
  const allstate = useSelector(state=>state);
  const loadingStatus = comMod.getLodingStatus(allstate);
  const com = useSelector(state=>state.com);
  const users = useSelector(state=>state.users);
  // サービス未設定の場合
  const service = useSelector(state=>state.service);
  const comAdic = comMod.findDeepPath(com, ['addiction', service]);  
  
  // 基本設定項目の確認
  if (loadingStatus.loaded && !comAdic && service){
    console.log('E49412');
    return(
      <StdErrorDisplay 
        errorText = '請求設定項目が未設定です。'
        errorSubText = {`予定作成開始に必要な基本設定項目がありません。設定メニューの
        「請求・加算」から定員や地域区分などを設定して下さい。`}
        errorId = 'E49412'
      />

    )
  }
  else if (loadingStatus.loaded && !users.length){
    console.log('E49413');
    return(
      <StdErrorDisplay 
        errorText = '利用者が未登録です。'
        errorSubText = {`利用者の登録をしてから予定の登録を行って下さい。`}
        errorId = 'E49413'
      />
    )
  }
  else if (loadingStatus.loaded && !loadingStatus.error){
    return(
      <ScheduleMain />
    )
  }
  else if (loadingStatus.error){
    return (
      <LoadErr loadStatus={loadingStatus} errorId={'E49418'} />
    )
  }
  else{
    return <LoadingSpinner/>
  }
}

export default Sch2;
